// extracted by mini-css-extract-plugin
export default {"headline":"Legal_headline__Rk7f3","subHeadline":"Legal_subHeadline__d+KpA","text":"Legal_text__gWJMo","container":"Legal_container__ia6iV"};